import {MenuStrategy} from "../MenuStrategy";

export class GestioneUtentiMenuStrategy extends MenuStrategy {
   constructor() {
    super('Gestione Utenti', 'Impostazioni - Gestione Utenti', 'app-gestione-utenti');
  }
}
